module.exports = __webpack_public_path__ + "static/img/logo_footer.7f7112a7.png";